import React, { useEffect, useState } from "react";
import HotelSearchBar from "../components/HotelSearchBar";
import SingleHotelRoomCard from "../components/SingleHotelRoomCard";
import AttentionBanner from "../components/AttentionBanner";
import SingleCityHotelsCard from "../components/SingleCityHotelsCard";
import PlaceHotelsAccordion from "../components/PlaceHotelsAccordion";
import Footer from "../components/Footer";
import ErrorAlert from "../admin/components/ErrorAlert";
import NothingToShow from "../components/NothingToShow";
import { useNavigate } from "react-router-dom";

export default function Home() {

  // Navigation
  const navigate = useNavigate();

  // State Handling
  const [error, setError] = useState("");
  const [fetchedHotels, setFetchedHotels] = useState([]);
  const [fetchedPlaces, setFetchedPlaces] = useState([]);

  // --------- Reading/Fetching Hotels From Database ---------
  const readingHotels = async () => {
    const response = await fetch("https://hotelbnb-backend.onrender.com/read-hotels");
    const result = await response.json();

    if (!response.ok) {
      setError("Sorry, Something went wrong");
    } else if (response.ok) {
      setError("");
      setFetchedHotels(result);
    }
  };

  // --------- Reading/Fetching Places From Database ---------
  const readingPlaces = async () => {
    const response = await fetch("https://hotelbnb-backend.onrender.com/read-places");
    const result = await response.json();

    if (!response.ok) {
      setError("Sorry, Something went wrong");
    } else if (response.ok) {
      setFetchedPlaces(result);
    }
  };

  useEffect(() => {
    readingHotels();
    readingPlaces();
  }, []);

  return (
    <>
      {/* Hero Section Start */}
      <div className="container-fluid p-0 hero-section hero-section-spacing">
        <div className="row justify-content-md-between justify-content-center align-items-center app-container">
          <div className="col-11 col-xl-5 col-md-6 col-sm-9 pe-md-5 pe-xl-0 p-0 d-md-block d-flex flex-column justify-content-center align-items-center details-side">
            <h1 className="text-md-start text-center">
              Book with Ease, Stay with Pleasure
            </h1>
            <p className="hero-section-desc text-md-start text-center">
              Search through 5 million hotels in just a few seconds, Compare
              hotel prices and Discover a great deal to book.
            </p>
            <button onClick={() => {
              navigate("/book-now")
            }}
            className="custom-btn btn d-flex justify-content-center align-items-center rounded-pill">
              Book Now
              <i className="ms-2 fa-solid fa-circle-arrow-right"></i>
            </button>
            <div className="col-11 col-xl-9 col-lg-11 col-md-12 col-sm-9 hero-section-review d-inline-flex justify-content-center align-items-center gap-lg-3 gap-2">
              <div className="p-0 m-0 happy-user-cover position-relative">
                <img
                  src="/images/happy-user.jpg"
                  alt="happy-user"
                  className="happy-user"
                />
                <span className="p-0 m-0"></span>
              </div>
              <p className="p-0 m-0">
                Awesome, this platform exceeded all expectations.
              </p>
            </div>
          </div>
          <div className="col-12 col-md-6 col-sm-9 mt-md-0 mt-sm-5 mt-4 p-sm-0 pt-2 image-side">
            <img
              src="/images/hero-image.jpg"
              alt="Hero-Image"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
      {/* Hero Section End */}

      {/* Hotel Search Bar Start */}
      <HotelSearchBar />
      {/* Hotel Search Bar End */}

      {/* Interesting Places/Hotels Start */}
      <div className="container-fluid p-0 interesting-places">
        <div className="row app-container">
          <div className="col-12 p-0 interesting-places-heading">
            <h1 className="text-sm-start text-center">Interesting Places</h1>
          </div>
        </div>
        <div className="row cards-container">
          <div className="col-12 d-flex flex-wrap p-0 interesting-places-cards justify-content-center justify-content-lg-start">
            {/* Showing Alert based on http request response if hotels can't be fetched Start */}
            {error && <ErrorAlert errorMsg={error} />}
            {/* Showing Alert based on http request response if hotels can't be fetched End */}

            {!fetchedHotels.length ? <NothingToShow /> : ""}

            {fetchedHotels?.slice(0, 3).map((singleHotel) => {
              return (
                <SingleHotelRoomCard
                  key={singleHotel._id}
                  id={singleHotel._id}
                  img={singleHotel.hotel_img}
                  title={singleHotel.hotel_name}
                  rating={singleHotel.hotel_rating}
                  ratingReview={singleHotel.hotel_rating_review}
                  cityAsLocation={singleHotel.hotel_city}
                  perDayPrice={singleHotel.hotel_per_day_price}
                  mb="0"
                />
              )
            })}
          </div>
        </div>
      </div>
      {/* Interesting Places/Hotels End */}

      {/* Prepare Your Trips With Us (Attention Banner) Start */}
      <AttentionBanner
        bgImg="/images/prep-trip.jpeg"
        title="Start Prepping Your Trips."
        text="Embark on a journey where comfort meets luxury, as exceptional
              hotels eagerly await to elevate your stay – discover the
              hospitality that await you!"
        btnText="See Places"
      />
      {/* Prepare Your Trips With Us (Attention Banner) End */}

      {/* Popular Searches/Cities Start */}
      <div className="container-fluid p-0 popular-searches interesting-places">
        <div className="row app-container">
          <div className="col-12 p-0 interesting-places-heading">
            <h1 className="text-sm-start text-center">Popular Searches</h1>
          </div>
        </div>
        <div className="row cards-container">
          <div className="col-12 d-flex flex-wrap p-0 interesting-places-cards justify-content-center justify-content-lg-start">
            {/* Showing Alert based on http request response if places can't be fetched Start */}
            {error && <ErrorAlert errorMsg={error} />}
            {/* Showing Alert based on http request response if places can't be fetched End */}

            {!fetchedPlaces.length ? <NothingToShow /> : ""}

            {fetchedPlaces?.slice(0, 3).map((singlePlace) => {
              return (
                <SingleCityHotelsCard
                  key={singlePlace._id}
                  img={singlePlace.place_img}
                  title={singlePlace.place_city}
                  totalNoOfHotels={
                    fetchedHotels?.filter((singleHotel) => {
                      return singleHotel.hotel_city == singlePlace.place_city;
                    })
                  }
                />
              )
            })}
          </div>
        </div>
      </div>
      {/* Popular Searches/Cities End */}

      {/* Search For Places / Accordions Start */}
      <div className="container-fluid p-0 search-for-places">
        <div className="row app-container">
          <div className="col-12 p-0 search-for-places-heading">
            <h1 className="text-sm-start text-center">Search For Places</h1>
          </div>
          <div
            className="col-12 p-0 accordion accordion-flush d-flex flex-wrap align-items-start gap-3 search-for-places-list"
            id="searchPlacesAccordion"
          >
            {!fetchedPlaces.length ? <NothingToShow /> : ""}
            
            {
              fetchedPlaces?.map((singlePlace) => {
                return (
                  <PlaceHotelsAccordion
                    key={singlePlace._id}
                    title={singlePlace.place_city}
                    hotelsArray={
                      fetchedHotels?.filter((singleHotel) => {
                        return singleHotel.hotel_city == singlePlace.place_city;
                      })
                    }
                  />
                )
              })
            }
          </div>
        </div>
      </div>
      {/* Search For Places / Accordions End */}

      {/* Footer Start */}
      <Footer />
      {/* Footer End */}
    </>
  );
}
